const setupBFCacheReload = (reloadFunction) => {
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      if (reloadFunction && typeof reloadFunction === 'function') {
        reloadFunction();
      } else {
        window.location.reload();
      }
    }
  });
}

module.exports = { setupBFCacheReload };